import React from "react";
import { Container, Row, Col, Card, Badge, Button } from "react-bootstrap";
import { FaEnvelope, FaCode, FaBullhorn } from "react-icons/fa";

const ContactUs = () => {
	return (
		<Container>
			<h1 className="text-start mt-4 mb-4 text-info fw-bold">CONTACT US</h1>

			<Card className="shadow mb-4 bg-dark text-white">
				<Card.Body>
					<Card.Text className="mb-4">
						Have questions, feedback, or need assistance with our fantasy
						mountain biking platform? We're here to help! For any technical
						issues, site functionality, or development related inquiries, please
						contact Kurtis. For marketing, partnerships, or content-related
						matters, Davi is your go-to contact.
					</Card.Text>

					<Card.Title className="border-bottom pb-2">
						<Badge bg="secondary" className="me-2">
							Team
						</Badge>
						Get In Touch
					</Card.Title>

					<Row className="mt-4">
						<Col md={6} className="mb-4">
							<Card className="h-100 shadow-sm bg-dark text-white">
								<Card.Header className="bg-info text-white">
									<FaCode className="me-2" /> Development & Site Inquiries
								</Card.Header>
								<Card.Body>
									<Card.Title className="fw-bold">Kurtis Gassewitz</Card.Title>
									<Card.Subtitle className="mb-3 text-info">
										Founder & Developer
									</Card.Subtitle>
									<Card.Text>
										For any fantasy questions (mountain bike fantasy - take it
										easy), technical issues, feature requests, bug reports, or
										general questions about the site functionality.
									</Card.Text>
									<Button
										variant="outline-info"
										href="mailto:kurtisgassewitz@gmail.com"
									>
										<FaEnvelope className="me-2" /> kurtisgassewitz@gmail.com
									</Button>
								</Card.Body>
							</Card>
						</Col>

						<Col md={6} className="mb-4">
							<Card className="h-100 shadow-sm bg-dark text-white">
								<Card.Header className="bg-info text-white">
									<FaBullhorn className="me-2" /> Marketing & Partnerships
								</Card.Header>
								<Card.Body>
									<Card.Title className="fw-bold">Davi Birks</Card.Title>
									<Card.Subtitle className="mb-3 text-info">
										Co-Founder & Content Creator
									</Card.Subtitle>
									<Card.Text>
										For partnerships, marketing opportunities, media inquiries,
										and content collaboration requests.
									</Card.Text>
									<Button
										variant="outline-info"
										href="mailto:info@theracecompanion.com"
									>
										<FaEnvelope className="me-2" /> info@theracecompanion.com
									</Button>
								</Card.Body>
							</Card>
						</Col>
					</Row>
				</Card.Body>
			</Card>
		</Container>
	);
};

export default ContactUs;
